<template>
  <div>
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-primary ml-5 mb-3" @click="$emit('goBack')" style="width: 100px;">< Kembali</button>
      </div>
      
      <div class="col-6 text-right">
         <button type="button" class="btn btn-success mr-5 mb-3" @click="print3Rangkap" style="width: 150px;">Print</button>
        <!-- <button type="button" class="btn btn-success mr-5 mb-3" @click="printPage" style="width: 100px;">Print</button> -->
      </div>
    </div>
    <div class="innerBox">
      <div id="printMe">
        <print-header></print-header>
    
        
        <div class="row conten">
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Work Order</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.form_code }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Tanggal Masuk</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.start_date.slice(0, 11) }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Nomor Polisi</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.registration }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Merk & Tipe</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.car_brand_name }} {{ printData.car_type_name }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Asuransi</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{printData.insurance_company_name}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Customer</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.customer_name }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Keterangan</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.detail }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-3 contentTitle" style="margin-top:8px;font-size:14px;font-weight: 700;">Administrasi</div>
              <div class="col-1 mt-2 font-weight-bold">:</div>
              <div class="col-8 contentVariable" style="font-size:26px;display: flex;flex-direction: column;justify-content: center;">{{ printData.administration }}</div>
            </div>
          </div>
        </div>
    
        <div class="row">
          <div class="col-3" style="padding:0 5%">
            <h5 class="text-center ttd" style="border-top: 3px solid black;padding-top:20px;margin-top:120px;">Kasir</h5>
          </div>
          <div class="col-3" style="padding:0 5%">
            <h5 class="text-center ttd" style="border-top: 3px solid black;padding-top:20px;margin-top:120px;">S A</h5>
          </div>
          <div class="col-3" style="padding:0 5%">
            <h5 class="text-center ttd" style="border-top: 3px solid black;padding-top:20px;margin-top:120px;">Kepala Bengkel</h5>
          </div>
          <div class="col-3" style="padding:0 5%">
            <h5 class="text-center ttd" style="border-top: 3px solid black;padding-top:20px;margin-top:120px;">Pemilik</h5>
          </div>
        </div>
    
      </div>
    </div>
  </div>
</template>

<script>
  import printHeader from '@/components/print/print_header.vue'
  import env from '@/env'

  export default {
    data () {
      return {

      }
    },
    props : ['printData'],
    components : {
      printHeader
    },
    mounted () {
      // this.printPage()
    },
    methods : {
      printPage(){
        // setTimeout(()=>{
        //   window.print();
        // }, 200)
        this.$htmlToPaper('printMe');
      },
      print3Rangkap() {

        this.$http({
            url : '/api/v1/workorder/print/printDoc',
            method : 'post',
            data : {
              type : 'printSJ',
              data : {
                form_code : this.printData.form_code,
                created_at : this.printData.start_date.slice(0, 11),
                registration : this.printData.registration,
                car_name : this.printData.car_type_name ,
                customer_name : this.printData.customer_name,
                insurance_name : this.printData.insurance_company_name,
                keterangan : this.printData.detail  ? this.printData.detail : '',
                administrasi : this.printData.administrasi ? this.printData.administrasi : '',
              }
            }
          })
          .then((resp) => {
            let data = resp.data.data
            console.log(data)
            // printJS(env.baseImage + '/' + data)
            // window.open()
            var prntWin = window.open("");
            prntWin.document.write("<html><head><title>"+name+"</title></head><body>" + 
            '<iframe width="100%" height="100%" name="plugin" src="'+env.baseImage + '/' + data+'"></iframe></body></html>');
            // prntWin.document.write(`
            //   <html>
            //     <body>
            //         <object data="${env.baseImage + '/' + data}" type="application/pdf">
            //             <embed src="${env.baseImage + '/' + data}" type="application/pdf" />
            //         </object>
            //     </body>
            //   </html>
            // `)
            // prntWin.print();

            
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>
  .documentTitle{
    font-size: 40px;
    border: 1px solid black;
    border-radius: 10px;
    padding:20px 30px;
  }
  .contentTitle{
    margin-top:8px;
    font-size:14px;
    font-weight: 700;
  }
  .contentVariable{
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size:26px;
  }
  .ttd{
    border-top: 3px solid black;
    padding-top:20px;
    margin-top:120px;
  }

</style>